export default __webpack_public_path__ + "static/media/goshen64.392347bc.jpg";